<app-preloader *ngIf="isLoading"></app-preloader>
<div class="extract collapsed" [id]="'deal' + indexDeal">
  <!--!isInsuranceEdition  -->
  <div class="title" *ngIf="!modeEdition">
    <div class="name">
      <label class="checkboxWrapper" [for]="indexDeal + 'deal'">
        <input
          type="checkbox"
          [id]="indexDeal + 'deal'"
          [(ngModel)]="deal.isSelected"
          [disabled]="!deal.payments || !deal.payments.length || userId != authService.currentUserIds || readOnlyActions"
          (click)="isSelected.emit($event)"
        />
        <span class="checkmark"></span>
        <span class="description">{{ deal.dealName }}</span>
      </label>
      @if (showDealLoyaltyBadge(deal)) {
      <span class="loyaltyBadge" tp="Propuesta Loyalty"
        ><img src="./assets/images/icons/loyalty.svg" alt="Ícono loyalty"
      /></span>
      }

      <div class="actions" *ngIf="userId == authService.currentUserIds && isValid && !readOnlyActions">
        <a (click)="edit.emit(indexDeal)" class="edit" tp="Editar propuesta">Editar</a>

        <a (click)="addInsurance()" class="insurance" tp="Agregar seguro" *ngIf="canAddInsurance() && !hasMarshInsurance">Agregar seguro</a>

        <a (click)="duplicate.emit(deal)" class="duplicate" tp="Duplicar propuesta">Duplicar</a>

        <a (click)="delete.emit(indexDeal)" class="delete" tp="Eliminar propuesta">Eliminar</a>
      </div>
    </div>
    <div class="wrapper-duplicate" *ngIf="!deal.result">
      <span class="description">Es necesario recalcular</span>
    </div>
    <div class="wrapper-duplicate" *ngIf="hasMarshInsuranceNotCalculated">
      <span class="description">Es necesario recalcular el seguro</span>
    </div>
    <div class="diroAndRorac">
      <div class="diro">
        <span>DIRO</span>
        <label>Quote ID</label>
        <a [href]="quoteUrl(deal)" target="_blank">
          {{ deal.profitDeal?.idQuote ? deal.profitDeal?.idQuote : ' -' }}
        </a>
        <label>Deal ID</label>
        <a [href]="dealUrl(deal)" target="_blank">
          {{ deal.profitDeal?.idDeal ? deal.profitDeal?.idDeal : ' -' }}
        </a>
      </div>
      <div class="rorac" *ngIf="deal.roRac">
        <span>RoRAC</span>
        <span>{{ deal.roRac }}%</span>
      </div>
    </div>
  </div>
  <div class="resume" *ngIf="!modeEdition">
    <div>
      <span>Producto Financiero</span>
      <span>{{ financialCalculator.getFinancialProduct(deal.financialProductType) }}</span>
    </div>
    <div>
      <span>Moneda</span>
      <span>{{ deal.currencyType }}</span>
    </div>
    <div>
      <span>Plazo</span>
      <span>{{ deal.term }}</span>
    </div>
    <div>
      <span>Tipo de producto</span>
      <span>{{ financialCalculator.getProductType(deal.productType) }}</span>
    </div>
    <div>
      <span>Condición</span>
      <span>{{
        financialCalculator.getClassificationType(deal.classification)
          ? financialCalculator.getClassificationType(deal.classification)
          : 'No Aplica'
      }}</span>
    </div>
    <div>
      <span>N° unidades</span>
      <span>{{ deal.quantity }}</span>
    </div>
    <div>
      <span>{{ getDisaplayPrice(deal) }}</span>
      <span>{{ getPrice(deal) | currency : "" : ""  }} </span>
    </div>
    <div>
      <span>Enganche</span>
      @if (deal.financialProductType == 'PURE_LEASING'){
      <span>No Aplica</span>
      } @else {
      <span>{{ deal.downPayment | currency : '' : '' }}</span>
      }
    </div>
    <div>
      <span>Total</span>
      <span>{{ getTotalPrice(deal) | currency : "" : "" }}</span>
    </div>
    @if (insuranceAmount != 0) {
    <div>
      <span>Seguro del vehículo</span>
      <span>{{ insuranceAmount | currency : '' : '' }}</span>
    </div>
    }

    <!-- Hacer clic en a.accordionControl hay que agregar o quitar la clase "collapsed" en el div.extract -->
    <a class="accordionControl" (click)="viewDeal(indexDeal)" tp="{{ collapsed ? 'Ver detalle' : 'Ocultar detalle' }}"
      ></a
    >
  </div>
  <div class="accordionWrapper">
    <div>
      <app-deal-view [deal]="deal" [isManualInsurance]="false" [nameCompany]="nameCompany" />
    </div>
  </div>
  <div *ngFor="let insurance of insuranceList; let i = index">
    <app-header-insurance
      [modeEditionProposal]="modeEdition"
      [deal]="insurance"
      [add]="add"
      [form]="insurance"
      [index]="i"
      [idQuote]="idQuote"
      [nameCompany]="nameCompany"
      [grace]="deal.grace"
      [userId]="userId"
      [indexDeal]="indexDeal"
      (delete)="deleteSeguro($event)"
      (update)="update($event)"
      (isSelectedInsurance)="selectedInsurance($event)"
      [isEnabled]="deal.isSelected"
      [isValid]="isValid"
      [readOnlyActions]="readOnlyActions"
    />
  </div>
</div>
